<button
  novaButton
  variant="tertiary"
  appTrackedButton
  [trackId]="'header:language-selector'"
  [matMenuTriggerFor]="languageMenu"
  aria-haspopup="true"
  [title]="'header.LANGUAGE_SELECTOR_TITLE' | translate"
>
  <nova-icon class="nova-button__icon-left" name="language"></nova-icon>
  <span>{{ getCurrentLanguageInfo().code.toUpperCase() }}</span>
</button>
<mat-menu #languageMenu="matMenu" class="rkt-menu">
  @for (language of availableLanguages; track language.code) {
    <button
      appTrackedButton
      [trackId]="`header:language-selector:${language.code}`"
      mat-menu-item
      class="rkt-menu__item"
      [title]="'header.LANGUAGE_SELECT_TITLE' | translate: {languageName: language.name}"
      (click)="selectLanguage(language)"
    >
      <span>{{ language.name }}</span>
      @if (language.code === currentLanguage()) {
        <span> ✓</span>
      }
    </button>
  }
</mat-menu>
